import httpClient from "@/common/service/HttpClient";
import { endPoints } from "@/constants/apiSetting";
const PayTypeService = {
  getAllPayType(obj) {
    return httpClient.post(endPoints.getPayType, obj);
  },
  updatePayType(obj) {
    return httpClient.post(endPoints.updatePayType, obj);
  },
  addPayType(obj) {
    return httpClient.post(endPoints.addPayType, obj);
  },
  deletePayType(obj) {
    return httpClient.post(endPoints.deletePayType, obj);
  },
};

export default PayTypeService;



// WEBPACK FOOTER //
// ./src/service/PayTypeService.js